<div class="items-brew-dialog"
  [ngClass]="{'fh': settingsManager.settings.theme == 'fh', 'modern': settingsManager.settings.theme == 'modern'}">

  <div class="scroll-container">
    <label class="title">
      <span [ghs-label]="'game.items.brewing'"></span>

      @if (gameManager.itemManager.brewingDisabled()) {
      <span class="brewing-disabled">
        <img src="./assets/images/close.svg"> <span [ghs-label]="'game.items.brewing.disabled'"></span>
      </span>
      }
    </label>

    <div class="table"
      [style.--ghs-summary-columns]="2 + brewing + (settingsManager.settings.fhShareResources ? -1 : 0)">
      @for (i of [] | ghsRange:brewing; track i) {
      <span class="head-col first">{{i+1}}.</span>
      }
      @if(!settingsManager.settings.fhShareResources) {
      <span class="first">
        <img class="icon character-icon" [src]="character.iconUrl" />
        <span class="name" [ngClass]="{'absent' : character.absent}">
          {{gameManager.characterManager.characterName(character)}}
        </span>
      </span>
      }
      <span class="first"><span [ghs-label]="'party.campaign.sheet.supply'"></span></span>

      @for (herb of herbs; track herb) {
      <span class="head-col calc-col toggle"
        [ngClass]="{'active' : receipe.length > 0 && receipe[0] == herb, 'disabled' : receipe[0] != herb && (character.progress.loot[herb] || 0) == 0 && (gameManager.game.party.loot[herb] || 0) == 0, 'spent' : receipe[0] != herb &&  ((characterSpent[herb] || 0) > 0  || (fhSupportSpent[herb] || 0) > 0) && (character.progress.loot[herb] || 0) <= (characterSpent[herb] || 0) && (gameManager.game.party.loot[herb] || 0) <= (fhSupportSpent[herb] || 0), 'forced': forced[0]}"
        ghs-pointer-input (singleClick)="toggleHerb(herb, 0)" (doubleClick)="toggleHerb(herb, 0, true)">
        <img class="ghs-svg" [src]="'./assets/images/fh/loot/' +  herb + '.svg'">
      </span>
      <span class="head-col calc-col toggle"
        [ngClass]="{'active' : receipe.length > 1 && receipe[1] == herb, 'disabled' : receipe[1] != herb && (character.progress.loot[herb] || 0) == 0 && (gameManager.game.party.loot[herb] || 0) == 0, 'spent' : receipe[1] != herb &&  ((characterSpent[herb] || 0) > 0  || (fhSupportSpent[herb] || 0) > 0) && (character.progress.loot[herb] || 0) <= (characterSpent[herb] || 0) && (gameManager.game.party.loot[herb] || 0) <= (fhSupportSpent[herb] || 0), 'forced': forced[1]}"
        ghs-pointer-input (singleClick)="toggleHerb(herb, 1)" (doubleClick)="toggleHerb(herb, 1,true)">
        <img class="ghs-svg" [src]="'./assets/images/fh/loot/' +  herb + '.svg'">
      </span>
      @if (brewing == 3) {
      <span class="head-col calc-col toggle"
        [ngClass]="{'active' : receipe.length > 2 && receipe[2] == herb, 'disabled' : receipe[2] != herb && (character.progress.loot[herb] || 0) == 0 && (gameManager.game.party.loot[herb] || 0) == 0, 'spent' : receipe[2] != herb &&  ((characterSpent[herb] || 0) > 0  || (fhSupportSpent[herb] || 0) > 0) && (character.progress.loot[herb] || 0) <= (characterSpent[herb] || 0) && (gameManager.game.party.loot[herb] || 0) <= (fhSupportSpent[herb] || 0), 'forced': forced[2]}"
        ghs-pointer-input (singleClick)="toggleHerb(herb, 2)" (doubleClick)="toggleHerb(herb, 2, true )">
        <img class="ghs-svg" [src]="'./assets/images/fh/loot/' +  herb + '.svg'">
      </span>
      }
      @if(!settingsManager.settings.fhShareResources) {
      <span class="calc-col">
        @if (character.progress.loot[herb]) {
        <span class="value" [ghs-label]="'game.loot.' " [ghs-label-attribute]="'title'">
          {{characterSpent[herb] || '-'}} / {{character.progress.loot[herb] || 0}}
        </span>
        @if (characterSpent[herb] && (gameManager.game.party.loot[herb] || 0) > (fhSupportSpent[herb] || 0)) {
        <a class="button" (click)="moveHerb(herb,characterSpent,fhSupportSpent)">
          <img class="ghs-svg" src="./assets/images/right.svg">
        </a>
        }
        }
        @if (!character.progress.loot[herb]) {
        <span>-</span>
        }
      </span>
      }
      <span class="calc-col">
        @if (gameManager.game.party.loot[herb]) {
        @if (fhSupportSpent[herb] && (character.progress.loot[herb] || 0) > (characterSpent[herb] || 0)) {
        <a class="button" (click)="moveHerb(herb,fhSupportSpent,characterSpent)">
          <img class="ghs-svg" src="./assets/images/left.svg">
        </a>
        }
        <span class="value" [ghs-label]="'game.loot.' " [ghs-label-attribute]="'title'">
          {{fhSupportSpent[herb] || '-'}} / {{gameManager.game.party.loot[herb] || 0}}
        </span>
        }
        @if (!gameManager.game.party.loot[herb]) {
        <span>-</span>
        }
      </span>
      }
    </div>

    @if (!applied) {
    <div class="receipe">
      @for (herb of receipe; track '' + herb + i; let i = $index) {
      <span class="herb" ghs-pointer-input (singleClick)="removeHerb(herb, false)"
        (doubleClick)="removeHerb(herb, false, i)">
        @if (!!herb) {
        <img class="ghs-svg" [src]="'./assets/images/fh/loot/' +  herb + '.svg'">
        }
        @if (!herb) {
        <img class="ghs-svg" src="./assets/images/fh/loot/unknown.svg">
        }
        @if (i < receipe.length -1) { <span>+</span>
      }
      </span>
      }
      @if (!brewed) {
      <span>=</span>
      }
      @if (!!item && !brewed ) {
      <span class="placeholder text-white item" [ghs-label]="'game.items.brewing.item'"
        [ghs-label-args]="[item.id, item.name, item.edition]"></span>
      }
      @if (!!brewed) {
      <span class="placeholder text-white item" [ghs-label]="'game.items.brewing.item'"
        [ghs-label-args]="[brewed.id, brewed.name, brewed.edition]"></span>
      }
      @if (!item && !brewed) {
      <span class="herb">
        <img class="ghs-svg" src="./assets/images/fh/loot/unknown.svg">
      </span>
      }
    </div>
    }

    @if (!!brewed && selectedCharacter) {
    <div class="receipe">
      <span class="placeholder text-white item"
        [ghs-label]="'game.items.brewing.brewed' + (selectedCharacter != character ? 'Other' : '')"
        [ghs-label-args]="[brewed.id, brewed.name, gameManager.characterManager.characterName(character,true) , selectedCharacter != character ? gameManager.characterManager.characterName(selectedCharacter,true): '']"></span>
    </div>
    }

    @if (!applied && characters.length > 0) {
    <div class="receipe">
      <span class="placeholder text-white item" [ghs-label]="'game.items.brewing.selectCharacter'"></span>
    </div>
    <div class="characters">
      @for (char of characters| trackUUID; track char._trackUUID) {
      <div class="character" (click)="selectedCharacter = char" [ngClass]="{'selected' : selectedCharacter == char}">
        <img class="icon" [src]="char.iconUrl" />
        <span class="name">
          {{gameManager.characterManager.characterName(char,true)}}
        </span>
      </div>
      }
    </div>
    }

    @if (characters.length == 0) {
    <div class="receipe">
      <span class="placeholder item already" [ghs-label]="'game.items.brewing.noChar'"></span>
    </div>
    }

    @if (!!brewed || !!item) {
    <div class="brewed">
      <ghs-item [item]="brewed || item" [flipped]="true" (click)="openItemDialog()"></ghs-item>
    </div>
    }

    <div class="menu">
      <a class="cancel" (click)="close()"><span [ghs-label]="'cancel'"></span></a>
      <a class="apply"
        [ngClass]="{'disabled' : !selectedCharacter || characters.length == 0 || applied || receipe.length < 2 || !receipe[0] || !receipe[1], 'unavailable': forced.includes(true) || gameManager.itemManager.brewingDisabled()}"
        ghs-pointer-input (singleClick)="brew()" (doubleClick)="brew(true)"><span
          [ghs-label]="'game.items.brewing.brew' + (selectedCharacter != character ? 'For' : '')"
          [ghs-label-args]="[selectedCharacter ? gameManager.characterManager.characterName(selectedCharacter, true) : '']"></span></a>
    </div>
  </div>
</div>